<template>
    <div :class="['search-box', {'search-hide': isCreamOn && isHideSearch}]" >
        <div v-show="isCreamOn && isHideSearch" class="search-hide-mask" @click="toggleSearch"><i class="down-icon"></i>展开筛选项</div>
        <div class="slot-operator clearfix" v-if="$slots.operatorbtn || $slots.operatorbar">
            <div class="pull-left">
                <slot name="operatorbtn"></slot>
            </div>
            <div class="pull-right">
                <slot name="operatorbar"></slot>
            </div>
        </div>
        <div class="form-ctn">
            <el-form
                :ref="formAttrs.ref || 'form'"
                :model="formData"
                :inline="true"
                :label-width="getLabelWidth"
                label-position="right"
                v-bind="formAttrs"
                size="small"
                @submit.native.prevent="submit"
                @reset.native.prevent="reset"
            >
                <div :style="getWrapperStyle">
                    <el-form-item
                        v-for="(field, index) in innerFields"
                        :key="`${field.model || field.slot}${index}`"
                        :prop="field.prop"
                        :rules="field.rules"
                        :style="{display: (index + 1) > maxShowNum && !showAll ? 'none' : 'inline-block'}"
                    >
                         <template slot="label">
                            <el-tooltip
                                effect="dark"
                                v-if="field.help"
                                :content="field.help"
                                placement="top-start"
                            >
                                <span class="el-icon-info"></span>
                            </el-tooltip>
                            <span>{{field.label}}</span>
                        </template>
                        <search-template
                            v-if="field.template"
                            v-model="formData[field.model]"
                            :tpl="field.template.tpl"
                            :style="{width: `${getTempWidth(field.template.attrs)}px`}"
                            :attrs="field.template.attrs"
                            v-on="field.template.events"
                        />
                        <template v-else>
                            <slot :name="field.slot" v-if="field.slot" />
                            <el-input
                                v-else
                                v-model.trim="formData[field.model]"
                                :placeholder="field.placeholder"
                                clearable
                                class="w180"
                                v-bind="field.itemAttrs"
                            />
                        </template>
                    </el-form-item>
                    <slot name="suffixCustomitems" />
                    <div :class="btnClass" :style="getBtnStyle">
                        <el-button
                            v-if="fields.length > maxShowNum"
                            @click="showAll = !showAll"
                            type="text"
                        >
                            <i :class="showAll ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" />
                            {{ displayText }}
                        </el-button>
                        <el-button
                            type="primary"
                            v-if="showSubmit"
                            native-type="submit"
                            class="search-btn"
                        >查询</el-button>
                        <el-button v-if="showReset" native-type="reset" class="reset-btn">重置</el-button>
                        <el-button v-if="showExport" @click="exportData">导出</el-button>
                        <span class="ml10">
                            <slot name="searchbtn"></slot>
                        </span>
                    </div>
                </div>
            </el-form>
        </div>
        <div v-if="isCreamOn" class="hide-search-button" @click.stop="toggleSearch">
          <i class="up-icon"></i>
          收起
        </div>
        <Divider v-if="withDivider" />
    </div>
</template>

<script>
import SearchTemplate from './templates';
import Divider from '../Divider';

export default {
    name: 'XxSearchForm',
    components: { SearchTemplate, Divider },
    props: {
        value: {
            required: false
        },
        // 每行元素个数
        lineNumber: {
            required: false,
            type: Number,
            default: () => 4
        },
        labelWidth: {
            type: String,
            default: () => '100px'
        },
        formAttrs: {
            type: Object,
            default: () => ({}),
            required: false
        },
        fields: {
            type: Array,
            required: false
        },
        center: {
            type: Boolean,
            default: false
        },
        showSubmit: {
            type: Boolean,
            default: true
        },
        showReset: {
            type: Boolean,
            default: true
        },
        showExport: {
            type: Boolean,
            default: false
        },
        maxShowNum: {
            type: Number,
            default: 8
        },
        /**
         * 支持用户定义是否按钮为新增行
         */
        isSameLine: {
            type: Boolean,
            default: true
        },
        /**
         * 自动包含下方的分割线（列表页常用）
         */
        withDivider: {
            type: Boolean,
            default: true
        },
        /** 按钮组class */
        btnClass: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            formData: this.value,
            showAll: this.fields.length < this.maxShowNum,
            isHideSearch: true,
        };
    },
    watch: {
        value: {
            deep: true,
            handler(newVal) {
                this.formData = newVal;
            }
        },
        formData: {
            deep: true,
            handler: function (newVal) {
                this.$emit('input', newVal);
            }
        }
    },
    computed: {
        isCreamOn() {
            return this.$mcCream && this.$mcCream.isCreamOn;
        },
        innerFields() {
            return this.fields.map(v => {
                if (v.template) {
                    if (v.template.attrs) {
                        if (!v.template.attrs.placeholder) {
                            v.template.attrs.placeholder = `请选择${v.label}`;
                        }
                    } else {
                        v.template.attrs = {
                            placeholder: `请选择${v.label}`
                        };
                    }
                } else if (!v.placeholder) {
                    v.placeholder = `请输入${v.label}`;
                }
                return v;
            });
        },
        displayText() {
            return this.showAll ? '收起' : '展开';
        },
        getIsSameLine() {
            const { isSameLine, fields, lineNumber } = this;
            if (!isSameLine) {
                return false;
            }
            return fields.length <= lineNumber && !(fields.length % lineNumber === 0);
        },
        getWrapperStyle() {
            return {
                display: 'flex',
                flexWrap: 'wrap'
            };
        },
        getBtnStyle() {
            return {
                textAlign: this.getIsSameLine ? 'left' : 'right',
                flex: 1,
                minWidth: '220px',
                marginBottom: '10px'
            };
        },
        getLabelWidth() {
            if (this.labelWidth) {
                return this.labelWidth;
            }
            let maxLength = 0;
            this.fields.forEach(item => {
                if (item.label.length > maxLength) {
                    maxLength = item.label.length;
                }
            });
            if (maxLength <= 4) {
                return `${80}px`;
            }
            if (maxLength > 4 && maxLength <= 6) {
                return `${90}px`;
            }
            if (maxLength > 6 && maxLength < 10) {
                return `${120}px`;
            }
            return `${100}px`;
        },
        validate() {
            return this.$refs.form.validate;
        }
    },
    methods: {
        toggleSearch() {
            if (!this.isCreamOn) return;
            this.isHideSearch = !this.isHideSearch;
        },
        submit() {
            this.$emit('submit');
        },
        reset() {
            this.$emit('reset');
        },
        exportData() {
            this.$emit('export');
            this.disabledExport = true;
            setTimeout(() => {
                this.disabledExport = false;
            }, 3e3);
        },
        getTempWidth(attrs = {}) {
            const { width, type } = attrs;
            if (width) {
                return width;
            }
            if (type === 'daterange') {
                return 210;
            }
            if (type === 'datetimerange') {
                return 340;
            }
            return 180;
        }
    }
};
</script>

<style lang="scss">
.search-box {
    position: relative;
    background: #fff;
    .slot-operator {
        border-bottom: 1px solid #eee;
        padding-bottom: 10px;
        margin-bottom: 10px;
    }
    .form-ctn {
        position: relative;
        .search-btn,
        .reset-btn {
            min-width: 0;
            // padding: 8px 20px;
        }
        .reset-btn {
            margin-left: 8px;
        }
    }
    .el-form-item {
        // margin-bottom: 10px;
        margin-bottom: 16px;
        white-space: nowrap;
    }
    .el-form-item--small .el-form-item__label {
        padding-right: 5px;
        // line-height: 26px;
    }
    .el-form-item--small .el-form-item__content {
        // line-height: 26px;
        min-width: 180px;
        .el-date-editor--daterange .el-range-input {
            min-width: 70px;
        }
    }
  &.search-hide {
    height: 30px;
    overflow: hidden;
    margin-bottom: 10px;
    .search-hide-mask {
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      background-color: white;
      z-index: 1;
      color: #4187ff;
      font-weight: bold;
      text-align: center;
      line-height: 30px;
      border-bottom: 1px solid #4187ff;
      .down-icon {
        border-top: 6px solid #4187ff;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-bottom: 7px solid transparent;
        display: inline-block;
        position: relative;
        top: 6px;
        margin-right: 4px;
      }
    }
  }
  .hide-search-button {
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-weight: bold;
    border-bottom: 1px solid #4187ff;
    color: #4187ff;
  }
  .up-icon {
    border-top: 7px solid transparent;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 6px solid #4187ff;
    display: inline-block;
    position: relative;
    top: -2px;
  }
}
</style>
